module.exports = __webpack_public_path__ + "static/img/shine_pic1.8b81f97.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/shine_pic1.png
// module id = 5Pan
// module chunks = 1